import React, {useState, useEffect} from 'react'
import useAxiosPrivate from '../../context/hooks/useAxiosPrivate';
import {Table, Spinner} from 'react-bootstrap';
import ListPaginator from '../../components/ListPaginator';
import '../../appstyles/ClientsCSS/ClientsList.css';

function ProductInventoryList() {
    const axiosInstance = useAxiosPrivate();
    const [inventory, setInventory] = useState({ data: [] });
    const [loading, setLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

    const fetchInventoryProduct = (page, pageSize) => {
      setLoading(true)
      const url = `api/logistics-inventory/product-inventory/?page=${page}&size=${pageSize}`;

        axiosInstance.get(url)
        .then(response => {
          setInventory(response.data);
          setTotalPages(response.data.totalPages); 
        })
        .catch(error => {
          alert('Error al cargar el inventario. Por favor, inténtelo de nuevo más tarde.');
        })
        .finally(() => {
          setLoading(false)
        });
    }

  useEffect(() => {
    fetchInventoryProduct(currentPage, rowsPerPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, rowsPerPage, axiosInstance]);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    

  return (
    <div className='maestros-list'>
    <h2>Lista de Inventario por Producto</h2>
    <h5 style={{ fontSize: '1.1rem', fontWeight: '400', margin: '0.5rem 0' }}>A continuación se muesta la lista de inventario por producto y el stock disponible de cada uno.</h5>
    <hr />
    {loading ? (
      <div className='loading-container'>
        <Spinner animation="border" variant="info" style={{width: '4.5rem', height: '4.5rem'}} />
      </div>
    ) : (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>ID</th>
            <th>Producto</th>
            <th>Stock Disponible</th>
            <th>No. de Pedidos en Inventario</th>
            <th>Stock Comprado</th>
          </tr>
        </thead>
        <tbody>
          {inventory.data.map((product) => (
            <tr key={product.id}>
              <td>{product.product_id}</td>
              <td>{product.product_id__product_name}</td>
              <td>{product.available_stock} {product.unit}</td>
              <td>{product.available_inventories}</td>
              <td>{product.opening_stock} {product.unit}</td>
            </tr>
          ))}
        </tbody>
      </Table>      
    )}

    <ListPaginator
      currentPage={currentPage}
      totalPages={totalPages}
      rowsPerPage={rowsPerPage}
      onPageChange={handlePageChange}
      onRowsPerPageChange={value => {
        setRowsPerPage(value);
        setCurrentPage(1);
      }}
    />

    </div>
  )
}

export default ProductInventoryList